import { render, staticRenderFns } from "./PortfolioTable.vue?vue&type=template&id=47a30158&"
import script from "./PortfolioTable.vue?vue&type=script&lang=js&"
export * from "./PortfolioTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports